import React, { useEffect } from "react";

import FASTable from "../../../../../components/Tables/FASTable";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import {
  SupplierItemAmtFun,
  SupplierProItemAmt,
} from "../../../../../Redux/Slice/Fas/Profile Analysis/Supplier/SupplierSlice";
import { CustomerSupplierProAcDetail } from "../../../../../Redux/Slice/Fas/Profile Analysis/Customer/CustomerSlice";
import { Loader } from "../../../../../components/Loader/Loader";
import { useTheme } from "../../../../../Themecontext/Themecontext";

export default function MontlyItemAMT({
  accountName,
  accountGroup,
  startDate,
  endDate,
}) {
  const dispatch = useDispatch();
  const { Colourdata } = useSelector((state) => state.ClientLogin);
  const { SupplierItemAmtdata: SupplierItemRatedata } = useSelector(
    (state) => state.SupplierSlice,
  );
  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWFAS");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWFASDARK",
  );
  const { theme } = useTheme();
  const isdark = theme;
  const Firm = Cookies.get("Firm");
  const YearId = Cookies.get("FinancialYear");
  useEffect(() => {
    dispatch(SupplierItemAmtFun());
    dispatch(
      SupplierProItemAmt({
        Firm,
        Year: YearId,
        AcIDs: accountName.join(","),
        selectedIds: accountGroup.join(","),
        startDate: startDate,
        endDate: endDate,
      }),
    );
    dispatch(CustomerSupplierProAcDetail({ AcIDs: accountName }));
  }, [dispatch, Firm, YearId, accountGroup]);

  const getRows = SupplierItemRatedata?.Detail?.map((label, index) => ({
    // srNumber: index + 1,
    chart: true,
    ItemName: label.ItemName,
    AprAmt: label.AprAmt,
    MayAmt: label.MayAmt,
    JunAmt: label.JunAmt,
    JulAmt: label.JulAmt,
    AugAmt: label.AugAmt,
    SepAmt: label.SepAmt,
    OctAmt: label.OctAmt,
    NovAmt: label.NovAmt,
    DecAmt: label.DecAmt,
    JanAmt: label.JanAmt,
    FebAmt: label.FebAmt,
    MarAmt: label.MarAmt,
    TaxAmt: label.TaxAmt,
  }));

  const getColumns = [
    { label: "Chart", key: "charts", align: "center" },
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "Item Name",
      key: "ItemName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Total Amount", key: "TaxAmt", format: "true", align: "right" },
    { label: "Apr ", key: "AprAmt", format: "true", align: "right" },
    { label: "May ", key: "MayAmt", format: "true", align: "right" },
    { label: "Jun ", key: "JunAmt", format: "true", align: "right" },
    { label: "Jul ", key: "JulAmt", format: "true", align: "right" },
    { label: "Aug ", key: "AugAmt", format: "true", align: "right" },
    { label: "Sep ", key: "SepAmt", format: "true", align: "right" },
    { label: "Oct ", key: "OctAmt", format: "true", align: "right" },
    { label: "Nov ", key: "NovAmt", format: "true", align: "right" },
    { label: "Dec ", key: "DecAmt", format: "true", align: "right" },
    { label: "Jan ", key: "JanAmt", format: "true", align: "right" },
    { label: "Feb ", key: "FebAmt", format: "true", align: "right" },
    { label: "Mar ", key: "MarAmt", format: "true", align: "right" },
  ];

  if (SupplierItemRatedata === "no" || SupplierItemRatedata === null) {
    return (
      <div className="flex justify-center items-center h-screen text-xl text-[#502000]">
        <Loader />
      </div>
    );
  }

  return (
    <div style={{ marginTop: "20px" }}>
      <div
        style={{
          borderRadius: "12px",
          overflow: "hidden",
          boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
        }}
      >
        <div
          style={{
            backgroundColor:
              isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour4,
            color:
              isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour11,
            padding: "14px",
            margin: 0,
          }}
        >
          <h2
            style={{
              fontSize: "18px",
              margin: 0,
              letterSpacing: "1px",
              fontWeight: "600",
            }}
          >
            MONTHLY ITEM AMT
          </h2>
        </div>
        <FASTable data={getRows} columns={getColumns} />
      </div>
    </div>
  );
}
